import { getPlugin as getTranslationPlugin } from '@i18n/utils'

import translations from '../../components/TrustList/TrustList.translations'

export const satisfactionItem = ({ days }) => {
  const $t = getTranslationPlugin()

  return {
    id: 'reassurance_item_satisfaction',
    text: $t(translations.satisfaction, { days }),
    icon: 'IconGoodPrices',
  }
}
